import React from 'react'
import GenericEmrSubSectionComponent from 'src/mentor/components/EmrRelatedComponents/components/GenericEmrSubSectionComponent'
import RepeatableActionSubSectionHandler from 'src/mentor/components/EmrRelatedComponents/components/RepeatableActionSubSectionHandler'
import {
  getCurrentSubSectionData,
  getSingleSubSectionDataHandler,
} from 'src/mentor/components/EmrRelatedComponents/utils/subSectionDataUtils'

export default function EmrSubSectionsHandler({
  subSections,
  subSectionsDataList,
  setSubSectionsDataList,
  layout = 'column', // Fallback default: 'column' | 'row' | 'grid'
  columns = 2, // Fallback default: Number of columns for grid layout
  spacing = 2, // Fallback default: Spacing between fields
  sectionLevelActions = [], // Actions from section level (for flexible routing)
  practitionerRole, // Current user's role (ROLE_DOCTOR, ROLE_SCREENER, etc.)
  runtime, // Runtime context for action path templating
}) {
  // console.log({subSectionsDataList}) // Removed to prevent loop logging
  return (
    <>
      {subSections?.map((subSection) => {
        // Detect if this subsection should use repeatable/action-based rendering
        // ============================================================
        // FLEXIBLE ACTION SOURCE CONFIGURATION
        // Choose which actions to pass to RepeatableActionSubSection
        // Uncomment the option you want to use:
        // ============================================================

        const subSectionLayout = subSection?.layoutConfig?.type || layout
        const subSectionColumns = subSection?.layoutConfig?.columns || columns
        const subSectionSpacing = subSection?.layoutConfig?.spacing || spacing

        // Option B: Use section-level actions (uncomment to switch)
        // const effectiveActions = sectionLevelActions || []

        // Option C: Fallback chain - try subsection first, then section
        // const effectiveActions = subSection?.actions || sectionLevelActions || []

        // Option D: Merge both (subsection actions + section actions)
        // const effectiveActions = [...(subSection?.actions || []), ...(sectionLevelActions || [])]

        // ============================================================

        const isRepeatable = subSection?.repeatable || false
        if (isRepeatable) {
          return (
            <RepeatableActionSubSectionHandler
              key={subSection?.uid}
              subSection={subSection}
              subSectionDataList={subSectionsDataList}
              setSubSectionsData={setSubSectionsDataList}
              practitionerRole={practitionerRole}
              runtime={runtime}
              maxItems={subSection?.maxItems}
              minItems={subSection?.minItems}
            />
          )
        }

        return (
          <GenericEmrSubSectionComponent
            key={subSection?.uid}
            subSection={subSection}
            subSectionData={getCurrentSubSectionData(subSectionsDataList, subSection)}
            setSubSectionsData={getSingleSubSectionDataHandler(setSubSectionsDataList,subSection)}
            layout={subSectionLayout}
            columns={subSectionColumns}
            spacing={subSectionSpacing}
          />
        )
      })}
    </>
  )
}
